/* eslint-disable space-before-blocks */
/* eslint-disable indent */
// openapp
var openShortLink = function (shortlink) {
    if (isWeixinQQWeibo()) {
        return;
    }
    var judge = canOpenShortLink()
    if (judge) {
        window.location = shortlink
    }
    setTimeout(() => {
        location.href = 'https://app.gaokaozhitongche.com/d'
    }, 2000)
};
var canOpenShortLink = function () {
    var navi = navigator.userAgent
    var n = navi.toLowerCase()
    var inandroid = n.match(/android/)
    var inios = n.match(/iphone/)
    return inandroid || inios
};
function isWeixinQQWeibo() {
    var ua = window.navigator.userAgent.toLowerCase();
    if ((ua.match(/\sQQ/i) == " qq" && ua.match(/iPhone/i) == "iphone") || (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/WeiBo/i) == "weibo")) {
        return true
    } else {
        return false
    }
}
const openapp = function openapp (shortlink) {
    if (isWeixinQQWeibo()) {
        alert('点击右上角，选择"其他浏览器"打开网页');
        return
    }
    // setTimeout(function () {
    //     window.location = 'https://app.gaokaozhitongche.com';
    // }, 3000)
    // var shortlink = 'gkztc://newsexam/h/<?php echo $model->hid;?>';
    openShortLink(shortlink)
}

export default openapp